<template>
  <div class="mx-4 ">
    <!-- <div class="row gy-2 mt-4" v-if="Cambios">
      <div v-for="(numero, index) in linksBI" :key="index.id" class="col col-3">
        <button
          @click="mostrar(numero.idLink , index)"
          class="bg-solimano w-100 py-3 px-0 mx-0"
        >
          {{ numero.nombreBi }}
        </button>
      </div>
    </div> -->
    <div>
        
      </div>


      <!-- <button class="btn btn-danger mb-2" @click="tokenbi()"> Presiona </button> -->

    <div v-if="carga"  class="contenedor" >
      <div class="marca-agua"></div> <!-- Agrega la marca de agua como fondo -->

  <SpinnerQhatu class="border-0 SpinnerQhatu"/>
</div>

    <div class=""  :class="{ invisible: carga }">
      <div :class="{ invisible: carga }">
        <div :class="{ invisible: carga }" id="powerBIcontainer"></div>
    </div>
      </div>


    

    </div>



  
</template>

<script>

import SpinnerQhatu from "@/components/SpinnerQHATU/Spinne.vue";
import { mapGetters , mapActions} from "vuex";
import * as pbi from "powerbi-client";



export default {
  name: "BYCliente",
  components: {
    SpinnerQhatu,

  },

  data() {
    return {
      linksBI: [],
      parametroBI: [],
      carga: true,
      embedConfig: {
        type: 'report',
        tokenType: pbi.models.TokenType.Embed,
        accessToken: '',
        embedUrl: '',
        id: '',
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: true
        }
      },
      report: null,
    };
  },

  watch: {
    $route() {
      // El código que deseas ejecutar cuando cambia la ruta
      this.cargarLinkPowerBI();
    },

    activarTokenbi(newValue) {
    if (newValue) {
      this.tokenbi();
      
      // Resetear la bandera en Vuex después de ejecutar la función
      this.$store.commit('users/activarTokenbi', false);
    }
  }
  },

  mounted() {
    this.cargarLinkPowerBI();




  },

  created(){
    this.getAttributes();

  },



  computed: {
    ...mapGetters("acciones", ["Cambios"]),
    ...mapGetters("users", ["Items", "ModuloRapido", "IconoModulo","Idreporte","Idgrupo"]),

    activarTokenbi() {
    return this.$store.getters['users/ActivarTokenbi'];
  }

  },
  methods: {
    ...mapActions("users", ["getAttributes"]),

    ...mapActions("acciones", [
      "ListarPerfil",
      "ListarCatxPerfil",
      "ListarCategorias",
      "ListarModulo",
      "ListarPerfilxUsuario",
      "ListarUsuarios",
    ]),

   
    // mostrar(id, index) {
    cargarLinkPowerBI() {
      this.parametroBI = []; // Limpiar el array al inicio
      this.carga = true
      console.log(this.$route.params.idCategoria);
      this.axios
        .get(
          `BIClientes/EncontrarLinkBi?idCategoria=${this.$route.params.idCategoria}`
        )
        .then((r) => {
          console.log(r.data);
          this.parametroBI = r.data;
          setTimeout(() => {
            this.carga = false; // Desactivar el spinner
          }, 8000);
        });
    },

   tokenbi() {

    console.log(this.ModuloRapido)
  
  const WORKSPACE_ID = `${this.Idgrupo}`; // Reemplaza con el valor correcto
  const REPORT_ID = `${this.Idreporte}`; // Reemplaza con el valor correcto
  //https://pythongruposolimano.com.pe/api/

  console.log('PRUEBA',this.Idgrupo)
  this.axios
    .get("https://pythonbi.gruposolimano.com.pe/getembedinfo", {
      params: {
        WORKSPACE_ID: WORKSPACE_ID,
        REPORT_ID: REPORT_ID
      },
      // withCredentials: true 
      // 💥 IMPORTANTE para enviar cookies
    })
    .then((response) => {
      if (response.status === 200 && response.data && response.data.reportConfig) {
        this.embedConfig.accessToken = response.data.accessToken;
        this.embedConfig.embedUrl = response.data.reportConfig[0].embedUrl;
        this.embedConfig.id = response.data.reportConfig[0].reportId;

        console.log("Embed Config:", this.embedConfig);
        this.embedReport();
      } else {
        console.error("Unexpected response structure:", response.data);
      }
    })
    .catch((error) => {
      console.error("Error fetching embed info:", error);
    });
},



embedReport() {
  const reportContainer = document.getElementById("powerBIcontainer");

  // Si ya existe un informe incrustado en el contenedor, restablecerlo
  const powerbiService = new pbi.service.Service(
    pbi.factories.hpmFactory,
    pbi.factories.wpmpFactory,
    pbi.factories.routerFactory
  );

  // Restablece el contenedor antes de incrustar el nuevo informe
  powerbiService.reset(reportContainer);
  
  // Incrusta el nuevo informe
  this.report = powerbiService.embed(reportContainer, this.embedConfig);

  // Maneja eventos de carga y errores
  this.report.off("loaded");
  this.report.off("rendered");
  this.report.on("error", function () {
    console.error("Error embedding the report");
  });

  // Oculta el spinner y resetea el estado
  this.carga = false;
  this.$store.commit('users/activarTokenbi', false);
}


    
    


 },
};
</script>

<style scoped>
.marca-agua {
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-image: url('../../assets/Principal/logoEspera.png');
  background-repeat: repeat;
  background-size: contain;
  z-index: -1;
}

.contenedor {
  position: relative;

}

.SpinnerQhatu {
  border: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#powerBIcontainer {
  width: 100%;
  height: 98vh; /* Ajusta la altura para que sea más grande */
}

iframe {
  width: 100%;
  height: 100%; /* Asegura que el iframe ocupe todo el contenedor */
}

.bg-solimano {
  background: #002c5d;
  color: white;
  border-radius: 15px;
  border: 1px solid transparent;
  transition: background-color 0.3s, border-color 0.3s;
  font-size: 0.8rem;
}

.bg-solimano:hover {
  background-color: #0055a4;
  border-color: white;
}

.invisible {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 5s, opacity 5s linear;
}
</style>
